import commonConstant from '../../common/_commonConstant';
import { getCookieToken, checkTimeToRefreshToken } from '../../common/_commonFunction';
import { history } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchGetParkingProblems = parkingID => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings/${parkingID}/parking-problems`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_PARKING_PROBLEMS_SUCCESS,
          'data': data.data ? data.data : [],
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.GET_PARKING_PROBLEMS_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_PARKING_PROBLEMS_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_PARKING_PROBLEMS_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchGetProblems = problemCode => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/problems${problemCode ? `?problemCode=${problemCode}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_PROBLEMS_SUCCESS,
          'data': data.data ? [...data.data] : [],
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.GET_PROBLEMS_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_PROBLEMS_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_PROBLEMS_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchCreateProblem = (parkingID, fromProblem) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings/${parkingID}/parking-problems`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'POST',
        'body': JSON.stringify(fromProblem),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.CREATE_PROBLEM_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.CREATE_PROBLEM_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.CREATE_PROBLEM_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CREATE_PROBLEM_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchUpdateProblem = (parkingID, parkingProblemID, fromProblem) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings/${parkingID}/parking-problems/${parkingProblemID}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'PUT',
        'body': JSON.stringify(fromProblem),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.UPDATE_PROBLEM_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.UPDATE_PROBLEM_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.UPDATE_PROBLEM_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.UPDATE_PROBLEM_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchDeleteProblem = (parkingID, parkingProblemID) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings/${parkingID}/parking-problems/${parkingProblemID}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'DELETE',
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.DELETE_PROBLEM_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.DELETE_PROBLEM_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.DELETE_PROBLEM_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);
